var render = function render(){var _vm=this,_c=_vm._self._c;return _c('side-bar',{attrs:{"title":_vm.title},scopedSlots:_vm._u([{key:"links",fn:function(props){return _vm._l((_vm.availableMenuItems),function(item){return _c('sidebar-item',{key:item.id,attrs:{"link":{ name: item.title, icon: 'now-ui-icons ' + item.icon, path: item.path }}})})}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }